import { render, staticRenderFns } from "./BlipTotalSentAndReceivedMessages.vue?vue&type=template&id=43dc2941&scoped=true&"
import script from "./BlipTotalSentAndReceivedMessages.vue?vue&type=script&lang=js&"
export * from "./BlipTotalSentAndReceivedMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dc2941",
  null
  
)

export default component.exports